<div id="mobile-container" class="w-100" *ngIf="component && this.currentPageDetail.pageTypeConfig === 'new'">
  <div [style.padding-top]="topPadding" [style.padding-bottom]="bottomPadding">
    <div [ngStyle]="pageContentStyle">
      <div
        [ngStyle]="mainWidgetStyling"
        [@pageTransition]="getParams(outlet)"
        (@pageTransition.done)="onTransitionDone()"
        (@pageTransition.start)="onTransitionStart()"
      >
        <ng-container *ngComponentOutlet="component.component; injector: component.injector"> </ng-container>
      </div>
    </div>

    <!-- Footer Widget Layout -->
    <div
      *ngIf="isFooterLayoutEnabled && footerComponent"
      class="max-h-fit z-[9999]"
      [ngStyle]="getFooterLayoutStyles()"
      [id]="LayoutNames.FOOTER_LAYOUT"
    >
      <ng-container
        *ngComponentOutlet="
          footerComponent.component;
          injector: footerComponent.injector;
          inputs: { footerLayoutStyles: footerOuterCss }
        "
      ></ng-container>
    </div>
    <!-- Footer Nav -->
    @if (!hideNavigationMenu) {
    <div *ngIf="isFooterVisible" class="pb-4 div-app-footer" id="div-app-footer">
      <app-footer-navbar (footerNavbarHeightChange)="setFooterNavbarHeight($event)"></app-footer-navbar>
    </div>
    }
  </div>
</div>
<div *ngIf="getApiStateAsLoader$ | async" class="position-absolute-fill loader-overlay">
  <div class="loader-container">
    <div class="loader"></div>
  </div>
</div>
<div *ngIf="!currentPageDetail" class="loader-container">
  <div class="loader"></div>
</div>
